(function () {
  'use strict';

  if (window.ksLocalWishlistController) {
    window.ksLocalWishlistController.refresh();
    return;
  }

  var STORAGE_KEY = 'ks_local_wishlist_handles_v1';
  var initialized = false;

  function parseList() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.filter(function (handle, index, self) {
        return typeof handle === 'string' && handle.length > 0 && self.indexOf(handle) === index;
      });
    } catch (error) {
      return [];
    }
  }

  function saveList(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {}
  }

  function hasHandle(handle) {
    return parseList().indexOf(handle) !== -1;
  }

  function addHandle(handle) {
    var list = parseList();
    if (list.indexOf(handle) === -1) {
      list.unshift(handle);
      saveList(list);
    }
    return list;
  }

  function removeHandle(handle) {
    var list = parseList().filter(function (item) {
      return item !== handle;
    });
    saveList(list);
    return list;
  }

  function toggleHandle(handle) {
    if (!handle) return parseList();
    return hasHandle(handle) ? removeHandle(handle) : addHandle(handle);
  }

  function canUseWishlist(button) {
    var root = button.closest('[data-ks-wishlist-product]');
    return !!root && root.getAttribute('data-customer-logged-in') === 'true';
  }

  function setLoginNotice(button, isOpen) {
    var root = button.closest('[data-ks-wishlist-product]');
    var notice = root && root.querySelector('[data-ks-wishlist-login]');
    if (!notice) return;

    button.setAttribute('aria-controls', notice.id);
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    notice.classList.toggle('is-open', isOpen);
    notice.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    notice.toggleAttribute('inert', !isOpen);

    var status = root.querySelector('[data-ks-wishlist-login-status]');
    var message = notice.querySelector('p');
    if (status) status.textContent = isOpen && message ? message.textContent : '';
  }

  function updateProductButtons() {
    var buttons = document.querySelectorAll('[data-ks-wishlist-toggle]');
    buttons.forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var saved = canUseWishlist(button) && hasHandle(handle);
      var addLabel = button.getAttribute('data-add-label') || 'お気に入りに追加';
      var removeLabel = button.getAttribute('data-remove-label') || 'お気に入りから削除';
      var label = button.querySelector('[data-ks-wishlist-label]');
      if (label) {
        label.textContent = saved ? removeLabel : addLabel;
      } else {
        button.textContent = saved ? removeLabel : addLabel;
      }
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-active', saved);
    });
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;

    if (isNaN(number) || number == null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents) {
    var config = window.ksLocalWishlistConfig || {};
    var format = config.moneyFormat || '¥{{amount_no_decimals}}';
    var value = '';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) return format;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(match[0], value);
  }

  function getRootUrl() {
    var config = window.ksLocalWishlistConfig || {};
    var rootUrl = config.rootUrl || window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return rootUrl.charAt(rootUrl.length - 1) === '/' ? rootUrl.slice(0, -1) : rootUrl;
  }

  function productEndpoint(handle) {
    return getRootUrl() + '/products/' + encodeURIComponent(handle) + '.js';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function sizedImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    if (url.indexOf('_220x.') !== -1 || url.indexOf('?') !== -1) return url;
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(?:\?.*)?$/i, '_220x$1');
  }

  function renderProductCard(product) {
    var image = sizedImageUrl(product.featured_image || (product.images && product.images[0]) || '');
    var price = typeof product.price_min === 'number' ? product.price_min : product.price;
    var title = escapeHtml(product.title || '');
    var url = product.url || (getRootUrl() + '/products/' + encodeURIComponent(product.handle));
    var handle = escapeHtml(product.handle || '');

    return '' +
      '<article class="ks-account-wishlist-card" data-ks-wishlist-card="' + handle + '">' +
        '<div class="ks-account-wishlist-card__media">' +
          '<a class="ks-account-wishlist-card__image-link" href="' + escapeHtml(url) + '">' +
            (image ? '<img class="ks-account-wishlist-card__image" src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">' : '<div class="ks-account-wishlist-card__image-placeholder" aria-hidden="true"></div>') +
          '</a>' +
        '</div>' +
        '<div class="ks-account-wishlist-card__footer">' +
          '<div class="ks-account-wishlist-card__body">' +
            '<h3 class="ks-account-wishlist-card__title"><a href="' + escapeHtml(url) + '">' + title + '</a></h3>' +
            '<p class="ks-account-wishlist-card__price">' + escapeHtml(formatMoney(price || 0)) + '<span class="price-tax-note">（税込）</span></p>' +
          '</div>' +
          '<button type="button" class="ks-account-wishlist-card__remove" data-ks-wishlist-remove="' + handle + '">削除</button>' +
        '</div>' +
      '</article>';
  }

  function renderWishlistSection(section) {
    if (!section) return;

    var grid = section.querySelector('[data-ks-wishlist-grid]');
    var status = section.querySelector('[data-ks-wishlist-status]');
    var emptyMessage = section.getAttribute('data-empty-message') || 'お気に入り商品はまだありません。';
    var errorMessage = section.getAttribute('data-error-message') || '一部の商品情報を読み込めませんでした。';
    var handles = parseList();

    if (!grid || !status) return;

    grid.innerHTML = '';

    if (!handles.length) {
      status.textContent = emptyMessage;
      section.classList.add('is-empty');
      return;
    }

    section.classList.remove('is-empty');
    status.textContent = '読み込み中です。';

    Promise.all(handles.map(function (handle) {
      return fetch(productEndpoint(handle), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found: ' + handle);
          return response.json();
        })
        .then(function (product) {
          return renderProductCard(product);
        })
        .catch(function () {
          return '';
        });
    })).then(function (cards) {
      var html = cards.filter(Boolean).join('');
      grid.innerHTML = html;
      status.textContent = html ? '' : errorMessage;
      if (!html) section.classList.add('is-empty');
    });
  }

  function renderAccountWishlist() {
    var sections = document.querySelectorAll('[data-ks-wishlist-account]');
    sections.forEach(function (section) {
      renderWishlistSection(section);
    });
  }

  function bindEvents() {
    if (initialized) return;
    initialized = true;

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-ks-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        if (!canUseWishlist(toggle)) {
          updateProductButtons();
          setLoginNotice(toggle, true);
          return;
        }
        toggleHandle(toggle.getAttribute('data-product-handle'));
        updateProductButtons();
        renderAccountWishlist();
        return;
      }

      var remove = event.target.closest('[data-ks-wishlist-remove]');
      if (remove) {
        event.preventDefault();
        removeHandle(remove.getAttribute('data-ks-wishlist-remove'));
        updateProductButtons();
        renderAccountWishlist();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var root = event.target.closest('[data-ks-wishlist-product]');
      var notice = root && root.querySelector('[data-ks-wishlist-login].is-open');
      var button = root && root.querySelector('[data-ks-wishlist-toggle]');
      if (!notice || !button) return;
      setLoginNotice(button, false);
      button.focus({ preventScroll: true });
    });

    document.addEventListener('shopify:section:load', init);
    window.addEventListener('pageshow', updateProductButtons);

    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY || event.key === null) {
        updateProductButtons();
        renderAccountWishlist();
      }
    });
  }

  function init() {
    bindEvents();
    updateProductButtons();
    renderAccountWishlist();
  }

  window.ksLocalWishlistController = { refresh: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
